import SpotCheckPage from './SpotCheckPage';
export default SpotCheckPage;